import {
  Home,
  CalendarDays,
  Heart,
  Wallet,
  Bell,
  Users,
  Settings,
  FileText,
  MessageCircle,
  type LucideIcon,
} from 'lucide-react'
import { usePermissions } from '@/hooks'
import type { Permission } from '@/types'

export interface NavItem {
  name: string
  href: string
  icon: LucideIcon
  badge?: boolean
  permission?: Permission
  caregiverOnly?: boolean
}

export const navigation: NavItem[] = [
  { name: 'Home', href: '/', icon: Home },
  { name: 'Calendar', href: '/calendar', icon: CalendarDays },
  { name: 'Health', href: '/health', icon: Heart, permission: 'view_health' },
  { name: 'Money', href: '/financial', icon: Wallet, permission: 'view_financial' },
  { name: 'Alerts', href: '/alerts', icon: Bell, badge: true, caregiverOnly: true },
  { name: 'Family', href: '/family', icon: Users },
  { name: 'Chat', href: '/chat', icon: MessageCircle },
  { name: 'Reports', href: '/reports', icon: FileText, caregiverOnly: true },
]

export const secondaryNavigation: NavItem[] = [
  { name: 'Settings', href: '/settings', icon: Settings },
]

/**
 * Returns the primary navigation items the current user is allowed to see,
 * applying the same permission and role gating everywhere navigation is
 * rendered (desktop Sidebar and MobileNav).
 */
export function useFilteredNavigation(): NavItem[] {
  const { hasPermission, isCaregiver } = usePermissions()

  return navigation.filter((item) => {
    // Check permission requirement
    if (item.permission && !hasPermission(item.permission)) {
      return false
    }
    // Check caregiver-only requirement
    if (item.caregiverOnly && !isCaregiver) {
      return false
    }
    return true
  })
}
